/**
 * Hook for managing rate type filtering state and logic
 */

import { useCallback, useState } from 'react';
import type { RateType } from '../types/rate-shop-types';

interface UseRateShopFilteringReturn {
  rateType: RateType;
  setRateType: (rateType: RateType) => void;
  isLowestRate: boolean;
  isBestFlexRate: boolean;
  toggleRateType: () => void;
}

export function useRateShopFiltering(
  initialRateType: RateType = 'lowest',
): UseRateShopFilteringReturn {
  const [rateType, setRateType] = useState<RateType>(initialRateType);

  const isLowestRate = rateType === 'lowest';
  const isBestFlexRate = rateType === 'best-flex';

  const toggleRateType = useCallback(() => {
    setRateType((current) => (current === 'lowest' ? 'best-flex' : 'lowest'));
  }, []);

  return {
    rateType,
    setRateType,
    isLowestRate,
    isBestFlexRate,
    toggleRateType,
  };
}
